import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as l from "react";
var s = l.createContext(null);
function a() {
  return {
    groups: new Map(),
    get: function get(o, e) {
      var i;
      var t = this.groups.get(o);
      t || (t = new Map(), this.groups.set(o, t));
      var n = (i = t.get(e)) != null ? i : 0;
      t.set(e, n + 1);
      var r = Array.from(t.keys()).indexOf(e);
      function u() {
        var c = t.get(e);
        c > 1 ? t.set(e, c - 1) : t.delete(e);
      }
      return [r, u];
    }
  };
}
function f(_ref) {
  var o = _ref.children;
  var e = l.useRef(a());
  return l.createElement(s.Provider, {
    value: e
  }, o);
}
function C(o) {
  var e = l.useContext(s);
  if (!e) throw new Error("You must wrap your component in a <StableCollection>");
  var t = l.useId(),
    _e$current$get = e.current.get(o, t),
    _e$current$get2 = _slicedToArray(_e$current$get, 2),
    n = _e$current$get2[0],
    r = _e$current$get2[1];
  return l.useEffect(function () {
    return r;
  }, []), n;
}
export { f as StableCollection, C as useStableCollectionIndex };